const config = require('../../../../../config/locales_json/packs/private/postulations/postulations.json');
const language = $('body').data("language");

initSpecifiqFilters()

function initSpecifiqFilters() {
  const filtersSelectize = $("#fj_postulations_filter .selectize-select");

  $.each(filtersSelectize, function(index, filter) {
    const filterObject = $(filter);
    if(filterObject.length > 0){
      filterObject.selectize({
        create: false
      });
    }
  });
}

jQuery(function() {
  const jobId = $(".recruiter #list_postulations").data("job");

  // Función para manejar la selección de todos los postulantes en una pestaña específica
  function handleSelectAll(tabId, selectAllId, allIdsName) {
    $('.recruiter #' + selectAllId).on('change', function(e){
      var allIds = $('.recruiter #' + allIdsName).val();
      if ($(this).is(':checked')) {
        localStorage.setItem("recruiterPostulantIds_" + tabId + "_" + jobId, allIds);
        $('.recruiter #' + tabId + ' input.check_postulant').prop("checked", true);
      } else {
        localStorage.setItem("recruiterPostulantIds_" + tabId + "_" + jobId, '');
        $('.recruiter #' + tabId + ' input.check_postulant').prop("checked", false);
      }
      updateBulkActionButtonState();
    });
  }

  // Función para manejar la selección individual de postulantes en una pestaña específica
  function handleIndividualSelect(tabId, selectAllId) {
    $(".recruiter #" + tabId).on("click", "input.check_postulant", function() {
      var value = $(this).val();
      var storedIds = localStorage.getItem("recruiterPostulantIds_" + tabId + "_" + jobId) || '';
      var allVals = storedIds === '' ? [] : storedIds.split(',');

      if (allVals.includes(value)) {
        allVals = allVals.filter(val => val !== value);
      } else {
        allVals.push(value);
      }

      localStorage.setItem("recruiterPostulantIds_" + tabId + "_" + jobId, allVals.join(','));
      $('.recruiter #' + tabId + ' input#' + selectAllId).prop("checked", allVals.length === $('#' + tabId + ' input.check_postulant').length);
      updateBulkActionButtonState();
    });
  }

  // Función para actualizar el estado del botón de acción masiva
  function updateBulkActionButtonState() {
    var fulfillIds = localStorage.getItem("recruiterPostulantIds_postulants-fulfill_" + jobId);
    var noFulfillIds = localStorage.getItem("recruiterPostulantIds_postulants-no-fulfill_" + jobId);
    var noTabsIds = localStorage.getItem("recruiterPostulantIds_postulants_" + jobId);
    var button = $('.recruiter button#menu_bulk_action');

    if ((!fulfillIds || fulfillIds === '') && (!noFulfillIds || noFulfillIds === '') && (!noTabsIds || noTabsIds === '')) {
      button.prop('disabled', true);
      button.addClass('disabled');
      $('.recruiter a#link_download_selected_mail').css('display', 'none');
      $('.recruiter a#selected_hirint_remainder').css('display', 'none');
      $('.recruiter a#massive_hirint_remainder').css('display', 'inline-flex');
    } else {
      button.prop('disabled', false);
      button.removeClass('disabled');
      $('.recruiter a#link_download_selected_mail').css('display', 'inline-flex');
      $('.recruiter a#selected_hirint_remainder').css('display', 'inline-flex');
      $('.recruiter a#massive_hirint_remainder').css('display', 'none');
    }
  }

  handleSelectAll('postulants-fulfill', 'check_for_select_all_fulfill', 'all_ids_fulfill');
  handleSelectAll('postulants-no-fulfill', 'check_for_select_all_no_fulfill', 'all_ids_no_fulfill');
  handleSelectAll('postulants', 'check_for_select_all_no_tabs', 'all_ids_no_tabs');

  handleIndividualSelect('postulants-fulfill', 'check_for_select_all_fulfill');
  handleIndividualSelect('postulants-no-fulfill', 'check_for_select_all_no_fulfill');
  handleIndividualSelect('postulants', 'check_for_select_all_no_tabs');

  // Inicialización del estado de los botones y checkboxes al cargar la página
  setTimeout(updateBulkActionButtonState, 0);

  // Evento para cambio masivo de estado
  $(".recruiter#postulation-list").on("click", "a.change_massive_state_link", function(e){
    e.preventDefault();
    
    var stateLink = $(this);
    var newStateLabel = stateLink.data('funnel-label');

    const fulfillIds = localStorage.getItem("recruiterPostulantIds_postulants-fulfill_" + jobId);
    const noFulfillIds = localStorage.getItem("recruiterPostulantIds_postulants-no-fulfill_" + jobId);
    const noTabsIds = localStorage.getItem("recruiterPostulantIds_postulants_" + jobId);
    const combinedIds = [...(fulfillIds ? fulfillIds.split(',') : []), ...(noFulfillIds ? noFulfillIds.split(',') : []), ...(noTabsIds ? noTabsIds.split(',') : [])].join(',');

    if (combinedIds.length === 0) {
      Swal.fire({
        title: "No hay postulantes seleccionados",
        icon: 'error',
        confirmButtonText: "Ok",
        width: '50rem',
        padding: '2rem'
      });
      return;
    }

    if (stateLink.data('send-mail')){
      const swalFireInfo = getTranslationValue(config, [language, "on_click_change_massive_state_link", "Swalfire_1"], { title: "¿Estas Seguro/a que deseas cambiar el estado?", inputPlaceholder: "Enviar correo de cambio de estado", confirmButtonText: "Sí", cancelButtonText: "Cancelar" });
      var newstate = stateLink.data('funnel-workflow');
      var showPreview = stateLink.data('feature-flag');
      
      // Se hace la petición para obtener el asunto y el correo correspondiente al cambio de funnel
      $.ajax({
        type: "GET",
        url: "/settings/fw/email/"+newstate,
        dataType: 'json'
      }).done(function(response, textStatus, jqXHR) {
        let data = response.data;
        swalFireChangeMassiveStatus(swalFireInfo, stateLink, combinedIds, newStateLabel, data, showPreview);
      }).fail(function(jqXHR, textStatus, errorThrown) {
        console.error(errorThrown);
        swalFireChangeMassiveStatus(swalFireInfo, stateLink, combinedIds, newStateLabel);
      })
    } else {
      const swalFireInfo = getTranslationValue(config, [language, "on_click_change_massive_state_link", "Swalfire_2"], { title: "¿Estas Seguro/a que deseas cambiar el estado?", confirmButtonText: "Sí", cancelButtonText: "Cancelar" });
      swalFireChangeMassiveStatus(swalFireInfo, stateLink, combinedIds, newStateLabel);
    }
  });

  // Evento para cambio individual de estado
  $(".recruiter#postulation-list, .recruiter#profileModal").on("click", "a.change_state_link", function(e){
    e.preventDefault();

    var stateLink = $(this);
    var newStateLabel = stateLink.data('funnel-label');

    if (stateLink.data('send-mail')){
      const swalFireInfo = getTranslationValue(config, [language, "on_click_change_state_link", "Swalfire_1"], { title: "¿Estas Seguro/a que deseas cambiar el estado?", inputPlaceholder: "Enviar correo de cambio de estado", confirmButtonText: "Sí", cancelButtonText: "Cancelar" });
      var newstate = stateLink.data('funnel-workflow');
      var showPreview = stateLink.data('feature-flag');

      // Se hace la petición para obtener el asunto y el correo correspondiente al cambio de funnel
      $.ajax({
        type: "GET",
        url: "/settings/fw/email/"+newstate,
        dataType: 'json'
      }).done(function(response, textStatus, jqXHR) {
        let data = response.data;
        swalFireChangeStatus(swalFireInfo, stateLink, newStateLabel, data, showPreview);
      }).fail(function(jqXHR, textStatus, errorThrown) {
        console.error(errorThrown);
        swalFireChangeStatus(swalFireInfo, stateLink, newStateLabel);
      })
    } else {
      const swalFireInfo = getTranslationValue(config, [language, "on_click_change_state_link", "Swalfire_2"], { title: "¿Estas Seguro/a que deseas cambiar el estado?", confirmButtonText: "Sí", cancelButtonText: "Cancelar" });
      swalFireChangeStatus(swalFireInfo, stateLink, newStateLabel);
    }
  });

  // Evento para enviar postulantes seleccionados por email
  $(".recruiter #list_postulations").on("click", "a#link_download_selected_mail", function(e) {
    e.preventDefault();
    var linkSelected = $(this);
    var AUTH_TOKEN = $('meta[name=csrf-token]').attr('content');
    var { isAdminUser, slug } = getSlugAndAdminStatus();
    const fulfillIds = localStorage.getItem("recruiterPostulantIds_postulants-fulfill_" + jobId);
    const noFulfillIds = localStorage.getItem("recruiterPostulantIds_postulants-no-fulfill_" + jobId);
    const noTabsIds = localStorage.getItem("recruiterPostulantIds_postulants_" + jobId);
    const combinedIds = [...(fulfillIds ? fulfillIds.split(',') : []), ...(noFulfillIds ? noFulfillIds.split(',') : []), ...(noTabsIds ? noTabsIds.split(',') : [])].join(',');

    if (combinedIds.length === 0) {
      Swal.fire({
        title: "No hay postulantes seleccionados",
        icon: 'error',
        confirmButtonText: "Ok",
        width: '50rem',
        padding: '2rem'
      });
      return;
    }

    var url = '/empresa/ofertas/' + linkSelected.data('ofert-id') + '/postulaciones/send_postulants';

    $.ajax({
      type: "GET",
      url: url,
      dataType: 'script',
      data: {
        ids: combinedIds,
        authenticity_token: AUTH_TOKEN
      }
    });
  });

  // Inicializar estados de checkboxes al cargar la página
  const fulfillCheckboxes = localStorage.getItem("recruiterPostulantIds_postulants-fulfill_" + jobId);
  if (fulfillCheckboxes) {
    fulfillCheckboxes.split(',').forEach(id => {
      $('.recruiter #postulants-fulfill #check_for_postulant_' + id).prop("checked", true);
    });
  }

  const noFulfillCheckboxes = localStorage.getItem("recruiterPostulantIds_postulants-no-fulfill_" + jobId);
  if (noFulfillCheckboxes) {
    noFulfillCheckboxes.split(',').forEach(id => {
      $('.recruiter #postulants-no-fulfill #check_for_postulant_' + id).prop("checked", true);
    });
  }

  const noTabsCheckboxes = localStorage.getItem("recruiterPostulantIds_postulants_" + jobId);
  if (noTabsCheckboxes) {
    noTabsCheckboxes.split(',').forEach(id => {
      $('.recruiter #postulants #check_for_postulant_' + id).prop("checked", true);
    });
  }

  setTimeout(updateBulkActionButtonState, 0);

  /*************
  *
  * Manejo de la acción de mostrar u ocultar el preview del correo
  */

  $(document).on('click', '.recruiter #preview-button-email', function() {
    let emailPreviewContainer = $(this).parent().find('#email-preview');
    let previewBtn = $('.recruiter #preview-button-email');

    const showPreviewText = getTranslationValue(config, [language, "preview_email_btn", "show"], "Preview del Correo");
    const hidePreviewText = getTranslationValue(config, [language, "preview_email_btn", "hide"], "Octular Preview");

    if (emailPreviewContainer.length) {
      let display = emailPreviewContainer.css('display');
      
      if (display === 'block') {
        emailPreviewContainer.css('display', 'none');
        previewBtn.text(showPreviewText);
      } else if (display === 'none') {
        emailPreviewContainer.css('display', 'block');
        previewBtn.text(hidePreviewText);
      } else {
        emailPreviewContainer.css('display', 'none');
        previewBtn.text(showPreviewText);
      }
    }
  });
  
});

$(document).ready(function() {

  $('.recruiter #isfavoriteModal').on("click", "#change_favorite", function(e){
    const disabledText = getTranslationValue(config, [language, "on_click_change_favorite_text"], "Enviando Información...");
    $(this).addClass("disabled").text(disabledText);
		$(".recruiter #isfavoriteModal").addClass("disabled");
	})

  $('.recruiter#postulation-list, .recruiter#profileModal').on("click", "#sendHirintEmailButton", function(e){
    var postulation_id = $(this).data('postulation-id');
    var AUTH_TOKEN = $('meta[name=csrf-token]').attr('content');

    Swal.fire({
      title: '¡Atención!',
      text: '¿Está seguro de enviar el correo?',
      icon: 'warning',
      allowEscapeKey: false,
      allowEnterKey: false,
      buttonsStyling: false,
      allowOutsideClick: false,
      confirmButtonText: 'Enviar',
      showCancelButton: true,
      cancelButtonText: 'Cancelar',
      customClass: {
          confirmButton: "btn btn-fj-purple",
          cancelButton: "btn btn-light"
      }
    }).then((result) => {
        if (result.isConfirmed) {
          // Realizar la activación o desactivación del servicio
          sendHirintEmailAction(postulation_id, AUTH_TOKEN)
        }
    });

  });

  function sendHirintEmailAction(postulation_id, AUTH_TOKEN) {
    Swal.fire({
      title: 'Realizando acción...',
      text: "Por favor espere mientras se procesa la acción",
      icon: 'info',
      allowEscapeKey: false,
      allowEnterKey: false,
      allowOutsideClick: false,
      showConfirmButton: false,
      showCancelButton: false,
    });
    // Consulta AJAX para activar o desactivar el servicio
    $.ajax({
      type: 'POST',
      url: '/send_hirint_email',
      dataType: 'script',
      data: {
        postulation_id: postulation_id,
        authenticity_token: AUTH_TOKEN
      },
      success: function(response, textStatus, jqXHR) {
        Swal.fire({
          title: '¡Correo Enviado!',
          text: 'El correo se ha enviado correctamente.',
          icon: 'success',
          allowEscapeKey: false,
          allowEnterKey: false,
          buttonsStyling: false,
          allowOutsideClick: false,
          customClass: {
            confirmButton: "btn btn-fj-purple",
          }
        });
      },
      error: function(jqXHR, textStatus, errorThrown) {
        // Muestra alerta indicando que hubo un error
        Swal.fire({
          text: 'Hubo un problema al enviar el correo. Por favor vuelve a intentar en unos minutos.',
          icon: "error",
          buttonsStyling: false,
          confirmButtonText: "Aceptar",
          customClass: {
            confirmButton: "btn btn-fj-purple"
          }
        });
      }
    });
  }

  $('.recruiter#postulation-list, .recruiter#profileModal').on("click", "#activateHirint", function(e){
    var AUTH_TOKEN = $('meta[name=csrf-token]').attr('content');
    var client_name = $(this).data('client-name');
    var client_countrie = $(this).data('client-country');

    Swal.fire({
      title: '¡Atención!',
      text: '¿Está seguro de solicitar el servicio?',
      icon: 'warning',
      allowEscapeKey: false,
      allowEnterKey: false,
      buttonsStyling: false,
      allowOutsideClick: false,
      confirmButtonText: 'Solicitar',
      showCancelButton: true,
      cancelButtonText: 'Cancelar',
      customClass: {
          confirmButton: "btn btn-fj-purple",
          cancelButton: "btn btn-light"
      }
    }).then((result) => {
      if (result.isConfirmed) {
        //Realizar la activación o desactivación del servicio
        sendHirintActivateSlack(client_name, client_countrie, AUTH_TOKEN)
      }
    });
  });

  function sendHirintActivateSlack(client_name, client_countrie, AUTH_TOKEN) {
    Swal.fire({
      title: 'Realizando acción...',
      text: "Por favor espere mientras se procesa la acción",
      icon: 'info',
      allowEscapeKey: false,
      allowEnterKey: false,
      allowOutsideClick: false,
      showConfirmButton: false,
      showCancelButton: false,
    });
    // Consulta AJAX para activar o desactivar el servicio
    $.ajax({
      type: 'POST',
      url: '/callback_slack_activate_hirint',
      dataType: 'json',
      data: {
        client_name: client_name,
        client_countrie: client_countrie,
        authenticity_token: AUTH_TOKEN
      },
      success: function(response, textStatus, jqXHR) {
        Swal.fire({
          title: '¡Solicitaste el servicio!',
          text: 'Alguien del equipo comercial te estará contactando próximamente.',
          icon: 'success',
          allowEscapeKey: false,
          allowEnterKey: false,
          buttonsStyling: false,
          allowOutsideClick: false,
          customClass: {
            confirmButton: "btn btn-fj-purple",
          }
        });
      },
      error: function(jqXHR, textStatus, errorThrown) {
        // Muestra alerta indicando que hubo un error
        Swal.fire({
          text: 'Hubo un problema al solicitarlo. Por favor vuelve a intentar en unos minutos.',
          icon: "error",
          buttonsStyling: false,
          confirmButtonText: "Aceptar",
          customClass: {
            confirmButton: "btn btn-fj-purple"
          }
        });
      }
    });
  }

  $('.recruiter#profileModal').on("show.bs.modal", function(e){
    var AUTH_TOKEN = $('meta[name=csrf-token]').attr('content');
    var active_panel = $(".recruiter #hirint.active.no-report")

    if (active_panel.length > 0) {
      var user_id = active_panel.data('userid');

      $.ajax({
        type: 'GET',
        url: '/get_hirint_test',
        dataType: 'script',
        data: {
          user_id: user_id,
          authenticity_token: AUTH_TOKEN
        },
        beforeSend: function() {
          // Muestra el mensaje "Cargando" usando SweetAlert2
          Swal.fire({
            title: 'Cargando Información',
            icon: 'info',
            allowEscapeKey: false,
            allowEnterKey: false,
            buttonsStyling: false,
            allowOutsideClick: false,
            showCancelButton: false,
            showConfirmButton: false
          });
        },
        success: function(response, textStatus, jqXHR) {
          Swal.close();
        },
        error: function(jqXHR, textStatus, errorThrown) {
          // Muestra alerta indicando que hubo un error
          Swal.fire({
            text: 'Hubo un problema al cargar el reporte. Por favor vuelve a intentar en unos minutos.',
            icon: "error",
            buttonsStyling: false,
            confirmButtonText: "Aceptar",
            customClass: {
              confirmButton: "btn btn-fj-purple"
            }
          });
        }
      });
    }
  })


  $('.recruiter#profileModal').on("click", "#hirintModalTab.no-report", function(e){
    var user_id = $(this).data('userid');
    var AUTH_TOKEN = $('meta[name=csrf-token]').attr('content');

    $.ajax({
      type: 'GET',
      url: '/get_hirint_test',
      dataType: 'script',
      data: {
        user_id: user_id,
        authenticity_token: AUTH_TOKEN
      },
      beforeSend: function() {
        // Muestra el mensaje "Cargando" usando SweetAlert2
        Swal.fire({
          title: 'Cargando Información',
          icon: 'info',
          allowEscapeKey: false,
          allowEnterKey: false,
          buttonsStyling: false,
          allowOutsideClick: false,
          showCancelButton: false,
          showConfirmButton: false
        });
      },
      success: function(response, textStatus, jqXHR) {
        Swal.close();
      },
      error: function(jqXHR, textStatus, errorThrown) {
        // Muestra alerta indicando que hubo un error
        Swal.fire({
          text: 'Hubo un problema al cargar el reporte. Por favor vuelve a intentar en unos minutos.',
          icon: "error",
          buttonsStyling: false,
          confirmButtonText: "Aceptar",
          customClass: {
            confirmButton: "btn btn-fj-purple"
          }
        });
      }
    });



  });

  $('.recruiter#profileModal').on('shown.bs.modal', function (e) {
    handleModalFooterSwipeButtons();
  })

  $('.recruiter#profileModal').on("click", "#swipe-actions button.swipe-btn", function(e) {
    var btn = $(this);
    swipeToRequest(btn);
  })

  $('.recruiter#profileModal').on("click", "#modal-footer-swipe-actions button.swipe-btn", function(e) {
    var clickedBtn = $(this);
    var swipeToNext = clickedBtn.hasClass('next');
    
    var swipeToBtnAction = swipeToNext ? $('#swipe-actions button.swipe-btn.next') : $('#swipe-actions button.swipe-btn.previous');
    if (swipeToBtnAction.length > 0) swipeToRequest(swipeToBtnAction);
  })

  // Evento para modificar url de acciones swipe
  $('.recruiter#profileModal').on("click", ".card-header.card-header-tabs-line a.nav-link", function(e) {
    var tabResume = $(this);
    var resumeParamValue = tabResume.data('resume');
    var swipeBtns = $('.recruiter#profileModal #swipe-actions button.swipe-btn');
    if (![null, undefined].includes(resumeParamValue) && swipeBtns.length > 0 ) {
      swipeBtns.each(function() {
        var btn = $(this);
        var oldHref = btn.data('href');
        btn.data('href', updateQueryParam(oldHref, 'resume', resumeParamValue));
      });
    }
  })

})

$(document).ready(function() {
  $(".recruiter .dropdown-hirint-massive-reminders").on("click", ".btn-hirint-massive-reminders", function(e) {
    e.preventDefault();
    var AUTH_TOKEN = $('meta[name=csrf-token]').attr('content');
    var btn = $(this);
    let sendAll = [true, "true"].includes(btn.data("all"));
    let lang = language ? language : "es";

    let postulantIds = sendAll ? [] : getSelectedPostulations();

    if (!sendAll && postulantIds.length === 0) {
      Swal.fire({
        title: "No hay postulantes seleccionados",
        icon: 'error',
        confirmButtonText: "Ok",
        width: '50rem',
        padding: '2rem'
      });
      return;
    }

    const hirintReminderTranslation = {
      "es": {
        "title": "¿Está seguro que quiere enviar recordatorio a todos los postulantes que no han respondido Hirint?",
        "titleMassive": "¿Está seguro que quiere enviar recordatorio a los [--nPostulants--] postulantes seleccionados?",
        "confirmButtonText": "Sí",
        "cancelButtonText": "No"
      },
      "en": {
        "title": "Are you sure you want to send a reminder to all applicants who have not responded to Hirint?",
        "titleMassive": "Are you sure you want to send a reminder to the [--nPostulants--] selected applicants?",
        "confirmButtonText": "Yes",
        "cancelButtonText": "No"
      },
      "pt": {
        "title": "Tem certeza de que deseja enviar um lembrete para todos os candidatos que não responderam ao Hirint?",
        "titleMassive": "Tem certeza de que deseja enviar um lembrete para os [--nPostulants--] candidatos selecionados?",
        "confirmButtonText": "Sim",
        "cancelButtonText": "Não"
      }
    }

    Swal.fire({
      title: sendAll ?  hirintReminderTranslation[lang].title : hirintReminderTranslation[lang].titleMassive.replace("[--nPostulants--]", postulantIds.length),
      icon: 'question',
      confirmButtonText: hirintReminderTranslation[lang].confirmButtonText,
      showCancelButton: true,
      cancelButtonText: hirintReminderTranslation[lang].cancelButtonText,
    })
    .then(function(result) {
      if (result.isConfirmed) {
        // Se hace la petición para iniciar el envío de correos
        $.ajax({
          type: "POST",
          url: "/hirint/send_massive_reminders",
          dataType: 'json',
          data: {
            authenticity_token: AUTH_TOKEN,
            postulation_ids: postulantIds,
            send_all: sendAll,
            ofert_id: btn.data("ofert-id")
          },
          beforeSend: function() {
            // Muestra el mensaje "Cargando" usando SweetAlert2
            Swal.fire({
              title: 'Iniciando envío...',
              icon: 'info',
              allowEscapeKey: false,
              allowEnterKey: false,
              buttonsStyling: false,
              allowOutsideClick: false,
              showCancelButton: false,
              showConfirmButton: false
            });
          },
          success: function(response, textStatus, jqXHR) {
            Swal.close();
            Swal.fire({
              title: '¡Proceso iniciado correctamente!',
              text: 'El envío de recordatorios inició sin problemas.',
              icon: 'success',
              allowEscapeKey: false,
              allowEnterKey: false,
              buttonsStyling: false,
              allowOutsideClick: false,
              customClass: {
                confirmButton: "btn btn-fj-purple",
              }
            });
          },
          error: function(jqXHR, textStatus, errorThrown) {
            // Muestra alerta indicando que hubo un error
            Swal.fire({
              text: 'Hubo un problema al intentar realizar el envio. Por favor vuelve a intentar en unos minutos.',
              icon: "error",
              buttonsStyling: false,
              confirmButtonText: "Aceptar",
              customClass: {
                confirmButton: "btn btn-fj-purple"
              }
            });
          }
        })
      }
    })
  })
})

$(document).ready(function() {
  // Evento para limpiar los usuarios seleccionados cuando se realiza un filtros
  $('.private-recruiter form#form-postulant-filter').on('submit', function() {
    let form = $(this);
    cleanSelectedCandidates(form);
  });

  // Evento para limpiar los usuarios seleccionados cuando se borran los filtros
  $('.private-recruiter #clean-filter-btn').on('click', function(e) {
    let form = $(".private-recruiter form#form-postulant-filter");    
    cleanSelectedCandidates(form);
  });
})

function swipeToRequest(swipeToBtnAction) {
  var btn = swipeToBtnAction;
  var AUTH_TOKEN = $('meta[name=csrf-token]').attr('content');
  var href = btn.data('href')
  var all_id_array = "";

  if ($(".recruiter #fulfill-postulants-tab.active").length > 0) {
    all_id_array = $('.recruiter input#all_ids_fulfill').val();
  } else if ($(".recruiter #no-fulfill-postulants-tab.active").length > 0) {
    all_id_array = $('.recruiter input#all_ids_no_fulfill').val();
  } else {
    all_id_array = $('.recruiter input#all_ids_no_tabs').val();
  }
  
  var queryParams = window.location.search;
  if (queryParams) queryParams = queryParams.replace('?', '&');

  var requestUrl = queryParams ?  href + queryParams : href
  var isDisabled = btn.hasClass('disabled')
  
  if (isDisabled) return;

  $('.recruiter button.swipe-btn').addClass('disabled');

  $.ajax({
    type: "POST",
    url: requestUrl,
    dataType: 'script',
    data: {
      authenticity_token: AUTH_TOKEN,
      all_postulants: all_id_array
    },
    beforeSend: function() {
      Swal.fire({
        title: 'Cargando',
        icon: 'info',
        allowEscapeKey: false,
        allowEnterKey: false,
        buttonsStyling: false,
        allowOutsideClick: false,
        showCancelButton: false,
        showConfirmButton: false
      });
    },
    success: function(response) {
      $('.recruiter button.swipe-btn').removeClass('disabled');
      handleModalFooterSwipeButtons();
      Swal.close();
    },
    error: function(xhr, status, error) {
      $('.recruiter button.swipe-btn').removeClass('disabled');
      $('.recruiter#profileModal button.swipe-btn').addClass('d-none');
      Swal.fire({
        text: 'Hubo un problema al cambiar de postulante. Intente cambiar manualmente. Si el problema se repite, contáctenos.',
        icon: "error",
        buttonsStyling: false,
        confirmButtonText: "Aceptar",
        customClass: {
          confirmButton: "btn btn-fj-purple"
        }
      });
    }
  });
}

function handleModalFooterSwipeButtons() {
  var swipeNextBtn = $(".recruiter #swipe-actions button.swipe-btn.next"); 
  var swipePreviousBtn = $(".recruiter #swipe-actions button.swipe-btn.previous");

  var modalSwipeNextBtn = $(".recruiter #modal-footer-swipe-actions button.swipe-btn.next"); 
  var modalSwipePreviousBtn = $(".recruiter #modal-footer-swipe-actions button.swipe-btn.previous");

  if (swipeNextBtn.length > 0 && modalSwipeNextBtn.length > 0) {
    var isShown = !swipeNextBtn.hasClass('d-none');
    if (isShown) {
      modalSwipeNextBtn.removeClass('d-none disabled');
    } else {
      modalSwipeNextBtn.addClass('d-none disabled');
    }
  } else {
    modalSwipeNextBtn.addClass('d-none disabled');
  }

  if (swipePreviousBtn.length > 0 && modalSwipePreviousBtn.length > 0) {
    var isShown = !swipePreviousBtn.hasClass('d-none');
    if (isShown) {
      modalSwipePreviousBtn.removeClass('d-none disabled');
    } else {
      modalSwipePreviousBtn.addClass('d-none disabled');
    }
  } else {
    modalSwipePreviousBtn.addClass('d-none disabled');
  }
}

function getTranslationValue(config, keys, defaultValue) {
	if (keys.length <= 1) return defaultValue;

	let currentTranslation;
	let firstIteration = true;

	for (let key of keys) {

	  if (firstIteration) {

      if (config[key]) {
        currentTranslation = config[key];
        firstIteration = false;
      } else {
        firstIteration = false;
        return defaultValue;
      }
	  } else {

      if (currentTranslation[key]) {
        currentTranslation = currentTranslation[key];
      } else {
        return defaultValue;
      }
	  }
	}

	return currentTranslation;
}

// Función para obtener el slug y verificar si el usuario es admin
function getSlugAndAdminStatus() {
  var isAdminUser = false;
  var slug = '';

  if ($(".recruiter #postulants-fulfill").length) {
    isAdminUser = $(".recruiter #postulants-fulfill").hasClass("admin");
    slug = $(".recruiter #postulants-fulfill").attr("data-slug");
  } else if ($(".recruiter #postulants-no-fulfill").length) {
    isAdminUser = $(".recruiter #postulants-no-fulfill").hasClass("admin");
    slug = $(".recruiter #postulants-no-fulfill").attr("data-slug");
  } else if ($(".recruiter #postulants").length) {
    isAdminUser = $(".recruiter #postulants").hasClass("admin");
    slug = $(".recruiter #postulants").attr("data-slug");
  }

  return { isAdminUser, slug };
}

function swalFireChangeStatus(swalFireInfo, stateLink, newStateLabel, data = undefined, showPreview = false) {
  var AUTH_TOKEN = $('meta[name=csrf-token]').attr('content');
  var postulationId = stateLink.data('postulation');
  var postulationList = $('.recruiter #postulants tbody tr');

  if ($(".recruiter #fulfill-postulants-tab.active").length > 0) {
    postulationList = $('.recruiter #table-fulfill tbody tr');
  } else if ($(".recruiter #no-fulfill-postulants-tab.active").length > 0) {
    postulationList = $('.recruiter #table-no-fulfill tbody tr');
  } else {
    postulationList = $('.recruiter #table-no-tabs tbody tr');
  }

  var postulationIndex =  postulationList.index($('#postulant-'+postulationId));
  var postulationCount = postulationList.length;
  let swalFireOptions = defineSwalFireOptionForStatusChange(data, swalFireInfo, showPreview, newStateLabel);

  Swal.fire(swalFireOptions)
  .then(function(result) {
    // Se revisa si se debe enviar correo o no
    var sendMail = $('#swal-checkbox').is(':checked') ? 'si' : 'no';

    var { isAdminUser, slug } = getSlugAndAdminStatus();

    var url = '/empresa/ofertas/' + stateLink.data('ofert') + '/postulaciones/'+ stateLink.data('postulation')+'/change_funnel_state';

    if (result.isConfirmed) {
      $.ajax({
        type: "POST",
        url: url,
        dataType: 'script',
        data: {
          postulation_id: stateLink.data('postulation'),
          new_state: stateLink.data('funnel-workflow'),
          send_mail: sendMail,
          slug: slug,
          postulation_index: postulationIndex,
          postulation_count: postulationCount,
          authenticity_token: AUTH_TOKEN
        }
      });
    }
  })
}

function swalFireChangeMassiveStatus(swalFireInfo, stateLink, postulation_ids, newStateLabel, data = undefined, showPreview = false) {
  var AUTH_TOKEN = $('meta[name=csrf-token]').attr('content');
  let swalFireOptions = defineSwalFireOptionForStatusChange(data, swalFireInfo, showPreview, newStateLabel, postulation_ids);
  
  Swal.fire(swalFireOptions)
  .then(function(result) {
    // Se revisa si se debe enviar correo o no
    var sendMail = $('#swal-checkbox').is(':checked') ? 'si' : 'no';
    var url = '/empresa/ofertas/' + stateLink.data('ofert') + '/postulaciones/change_massive_funnel_state';

    if (result.isConfirmed) {
      $.ajax({
        type: "POST",
        url: url,
        dataType: 'script',
        data: {
          postulation_ids: postulation_ids,
          new_state: stateLink.data('funnel-workflow'),
          send_mail: sendMail,
          authenticity_token: AUTH_TOKEN
        }
      });
    }
  })
}

function defineSwalFireOptionForStatusChange(data, swalFireInfo, showPreview, newStateLabel, postulation_ids = "") {
  var isDataPresent = data != undefined;
  // Las opciones se crean con los valores del Swalfire de no envío de correos
  let swalFiretitle = swalFireInfo['title'].replace("[--stateLabel--]", newStateLabel);
  swalFiretitle = swalFiretitle.replace("[--nPostulants--]", postulation_ids.split(",").length);

  let swalFireOptions = {
    title: swalFiretitle,
    icon: 'question',
    confirmButtonText: swalFireInfo['confirmButtonText'],
    showCancelButton: true,
    cancelButtonText: swalFireInfo['cancelButtonText'],
    width: '50rem',
    padding: '2rem',
    customClass: {
      popup: "custom-swal-popup custom-change-status-popup recruiter",
    }
  }
  // Se modifican las opciones para que se adapte al preview de correos
  if (isDataPresent && data["email_subject"] && data["email_message"]) {
    const showPreviewText = getTranslationValue(config, [language, "preview_email_btn", "show"], "Preview del Correo");
    var subject = data["email_subject"];
    var body = data["email_message"];
    var previewContainer = `
      <button id="preview-button-email" class="btn btn-secondary mt-4">${showPreviewText}</button>
      <div id="email-preview" style="display: none; margin: 10px 20px 0 20px;">
        <div id="email-preview-content" style="text-align: justify; margin-top:25px;">
        <strong>Asunto:</strong><br>${subject}
        <br><br>
        <strong>Cuerpo:</strong><br>${body}
        </div>
      </div>
    `;
    swalFireOptions.width = '70rem'
    swalFireOptions.html = `
      <div>
        <input type="checkbox" id="swal-checkbox">
        <label for="swal-checkbox">${swalFireInfo['inputPlaceholder']}</label>
      </div>
      ${ (isDataPresent && showPreview) ? previewContainer : "" }
    `;
    swalFireOptions.customClass = {
      content: 'email-preview-container',
      popup: "custom-swal-popup custom-change-status-popup recruiter"
    };
  }
  return swalFireOptions
}

function updateQueryParam(url, param, value) {
  var baseUrl = url.split('?')[0]; // Obtiene la url base
  var queryParams = url.split('?')[1]; // Obtiene los query params
  var newQueryParams = '';

  if (queryParams) {
      var params = new URLSearchParams(queryParams);
      params.set(param, value); // Establece el nuevo valor del parámetro (lo agrega si no existe)
      newQueryParams = params.toString();
  } else {
      newQueryParams = `${param}=${value}`;
  }

  return `${baseUrl}?${newQueryParams}`;
}

// Independiente del tipo de proceso, retorna todos los postulantes seleccionados
function getSelectedPostulations() {
  const jobId = $(".recruiter #list_postulations").data("job");
  const fulfillIds = localStorage.getItem("recruiterPostulantIds_postulants-fulfill_" + jobId);
  const noFulfillIds = localStorage.getItem("recruiterPostulantIds_postulants-no-fulfill_" + jobId);
  const noTabsIds = localStorage.getItem("recruiterPostulantIds_postulants_" + jobId);
  return [...(fulfillIds ? fulfillIds.split(',') : []), ...(noFulfillIds ? noFulfillIds.split(',') : []), ...(noTabsIds ? noTabsIds.split(',') : [])];
}

// Limpia las selecciones de postulantes
function cleanSelectedCandidates(form) {
  let submitUrlSplitted = form.attr("action").split("/");
  let ofertId = submitUrlSplitted[submitUrlSplitted.length - 2];

  // Resetear los valores en localStorage
  ["recruiterPostulantIds_postulants-fulfill_","recruiterPostulantIds_postulants-no-fulfill_","recruiterPostulantIds_postulants_"].forEach(function (ls) {
    let idsKey = ls + ofertId
    let ids = localStorage.getItem(idsKey)
    if (ids) localStorage.removeItem(idsKey);
  })
  
  // Desmarcar todos los checkboxes
  $('.recruiter input#check_for_select_all_no_tabs').prop("checked", false);
  $('.recruiter input#check_for_select_all_fulfill').prop("checked", false);
  $('.recruiter input#check_for_select_all_no_fulfill').prop("checked", false);
  $('.recruiter .check_postulant').prop("checked", false);
}